import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { DevicesFilters } from '@/api/routes/devices/types';
import smartSort from '@/utils/smartSort';

import { fetchDevicesFilters } from './actionCreators';
import { devicesFilters } from './mocks';

interface InitialState {
  devicesFilters: DevicesFilters,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  devicesFilters,
  isLoading: false,
  error: '',
};

export const devicesFiltersSlice = createSlice({
  name: 'devicesFilters',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchDevicesFilters.fulfilled.type]: (state, action: PayloadAction<DevicesFilters>) => {
      state.isLoading = false;
      state.error = '';
      state.devicesFilters = {
        tags: action.payload.tags?.sort(smartSort),
        content_source: action.payload.content_source?.sort(smartSort),
        surface_type: action.payload.surface_type?.sort(smartSort),
        profile: action.payload.profile?.sort(smartSort),
      };
    },
    [fetchDevicesFilters.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchDevicesFilters.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default devicesFiltersSlice.reducer;
